<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    alignment?: "start" | "center" | "end";
    avoidCollisions?: boolean;
    sideOffset?: number;
  }>(),
  {
    alignment: "center",
    avoidCollisions: true,
    sideOffset: 15,
  },
);

const isOpen = defineModel('isOpen', {default: false, type: Boolean});

const { alignment, avoidCollisions, sideOffset } = toRefs(props);
</script>
<template>
  <PopoverRoot v-model:open="isOpen">
    <PopoverTrigger>
      <slot />
    </PopoverTrigger>
    <!-- The popover is not portalled, so it stacks against the page chrome it
         opens over: the sticky session menu bar (z-50/z-51) and the call tiles'
         overlays (the mic level badge at z-10). It has to outrank those, and
         radix mirrors this z-index onto the floating wrapper it renders around
         the content. Kept below dialogs/modals (z-[80]+) so those still win. -->
    <PopoverContent
      :align="alignment"
      :avoidCollisions="avoidCollisions"
      :side-offset="sideOffset ?? 15"
      class="z-[500]"
    >
      <nav class="w-[300px] min-h-[50px] dark:text-white bg-midnight rounded">
        <div
          class="flex items-center px-4 py-3 bg-[#10151C] justify-between rounded-t w-full"
        >
          <div class="flex items-center gap-2 text-xs text-[#788291] w-full">
            <slot name="title" />
          </div>
        </div>
        <div class="w-full p-3 text-sm text-white text-white/80">
          <slot name="content" />
        </div>
      </nav>
      <PopoverArrow  />
    </PopoverContent>
  </PopoverRoot>
</template>